import TextField from "./Text";
import DropdownField from "./Dropdown";

export const Fields = {
  Text: TextField,
  Dropdown: DropdownField,
};